module.exports = __webpack_public_path__ + "img/libyan_arab_jamahiriya.519c9c8.webp";